// dependecies import ==>
import React from "react";
import Avatar from "@mui/material/Avatar";
// assets and scss import ==>
import "./myTransactionsHeader.scss";
// project file import ==>
import ClinicWrapper from "../../ClinicComponents/ClinicWrapper";
// constant import ==>
import { USER_TYPE } from "../../../Util/constants";

const MyTransactionsHeader = (props) => {
  const {
    userType,
    doctorClinicAssociation,
    staffClinicAssociation,
    doctorList,
    selectedDropdownValue,
    handleModal,
    displaySearchFilter,
    displayTransactionDropdown,
  } = props;

  const maxAvatars = window.innerWidth < 786 ? 1 : 2;

  // Helper Methods ===>

  const renderRemaining = () => {
    const remaining = doctorList?.length - maxAvatars;
    let dd = "+" + remaining.toString();
    if (remaining < 1) return null;
    return (
      <Avatar
        sx={{
          bgcolor: "#17BAE0",
          border: "2px solid white",
          boxSizing: "content-box",
          cursor: "pointer",
        }}
        style={{ position: "relative", left: `${-16 * maxAvatars + 1}px` }}
        src="/static/images/avatar/1.jpg"
        alt={dd}
        onClick={handleModal}
      >
        <p style={{ fontSize: "16px", margin: "0px", color: "white" }}>{dd}</p>
      </Avatar>
    );
  };

  const groupAvatar = () => {
    return (
      <>
        {doctorList?.slice(0, maxAvatars).map((ed, i) => (
          <Avatar
            alt={ed.dr_first_name}
            sx={{
              bgcolor: `${
                ed?.doctor_profile_picture_url?.length > 0 ? "white" : "#17BAE0"
              }`,
              border: "2px solid white",
              boxSizing: "content-box",
              cursor: "pointer",
            }}
            src={
              ed?.doctor_profile_picture_url?.length > 0 &&
              ed.doctor_profile_picture_url[0]
            }
            style={{ position: "relative", left: `${-16 * i}px` }}
            onClick={handleModal}
          />
        ))}
        {renderRemaining()}
      </>
    );
  };

  // <===

  // Create UI ===>

  const displayAdditionalHeaderUI = () => {
    return (
      window.innerWidth > 768 && (
        <div className="my-transactions-header-ui">
          {selectedDropdownValue === "My Transactions" && displaySearchFilter()}
          {displayTransactionDropdown()}
        </div>
      )
    );
  };

  const displayMyTransactionsHeader = () => {
    return (
      <div className="mytransactions-header">
        {doctorClinicAssociation === "true" ||
        staffClinicAssociation === "true" ? (
          <ClinicWrapper
            isPageHeading={true}
            headerText={"MY TRANSACTIONS"}
            displayAdditionalHeaderUI={displayAdditionalHeaderUI}
          />
        ) : (
          <div className="my-transactions-header">
            <div style={{ flex: "1" }}>
              <h4 className="my-transactions-heading d-flex">
                MY TRANSACTIONS
              </h4>
            </div>
            {window.innerWidth > 768 && (
              <>
                {selectedDropdownValue === "My Transactions" &&
                  displaySearchFilter()}
                {displayTransactionDropdown()}
              </>
            )}
            {userType === USER_TYPE.STAFF && groupAvatar()}
          </div>
        )}
      </div>
    );
  };

  // <===

  return (
    <div className="mytransactions-header-cont">
      {displayMyTransactionsHeader()}
    </div>
  );
};

export default MyTransactionsHeader;
